import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useModal } from '../contexts/ModalContext';

// Botão de alerta personalizado
export const NodeHeaderCustomAlertAction = ({ conferePendencias, nodeData }) => {
    const { showPendenciesModal } = useModal();

    const handleClick = () => {
        const pendenciasList = conferePendencias();
        showPendenciesModal(pendenciasList, nodeData?.label || 'Nó');
    };

    return (
        <button title="Mostrar Avisos" onClick={handleClick}>
            <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" />
        </button>
    );
};
